<mat-form-field>
  <mat-select [attr.data-size]="dataSize" [value]="selectedValue" (valueChange)="onSelectedValueChange($event)"  placeholder="{{placeHolder}}" [required]="required">
    <mat-option *ngFor="let year of years" [value]="year">
      {{year}}
    </mat-option>
  </mat-select>
</mat-form-field>
